import { render, staticRenderFns } from "./RegistrationProfileImage.vue?vue&type=template&id=fd31294a&scoped=true&"
import script from "./RegistrationProfileImage.vue?vue&type=script&lang=js&"
export * from "./RegistrationProfileImage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationProfileImage.vue?vue&type=style&index=0&id=fd31294a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd31294a",
  null
  
)

export default component.exports